import accessors from './accessors';
import actionTypes from './constants/action-types';
import constants from './constants';
import initializers from './initializers';
import middleware from './middleware';
import reducers from './reducers';
import selectors from './selectors';

export default {
  accessors,
  actionTypes,
  constants,
  initializers,
  middleware,
  reducers,
  selectors,
};
